import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import { Loader } from "@common/loader";
import { useGetUserInfo } from "@hooks/useGetUserProfile";
import { useNavigate } from "react-router";
import styles from "./styles.module.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getPredictionData } from "../prediction/utils/getPredictionData";

const OCCASIONS = {
  VACATION: "Vacation",
  WEDDING: "Wedding",
  HOLIDAY: "Holiday",
  SPORT_EVENT: "Sport event",
  REUNION: "Reunion",
  BIRTHDAY: "Birthday",
  OTHER: "Other event",
};

export const LoadingSlider = () => {
  const { loaded, user } = useGetUserInfo();
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const timeoutRef = useRef(null);

  const qqOccasion = user?.questions?.qqOccasion;
  const qqOccasionDate = user?.questions?.qqOccasionDate;

  const ms = localStorage.getItem("ms");
  const {
    goal,
    weight,
    eventWeight,
    isLoseWeight,
    isGainWeight,
    monthlyEstimateWeightChange,
  } = getPredictionData(user);

  const sliderData = [
    {
      title: (
        <div className={styles.flexboxFirst}>
          <p>Welcome to</p>
          <p>Walky</p>
        </div>
      ),
      text: "center",
      bg: "red",
      noPadding: true,
      duration: 2000,
    },
    {
      title: (
        <div className={styles.flexbox}>
          <p>
            <span>{user?.name},</span> Based on your answers,
          </p>
          <p></p>
        </div>
      ),
      bg: "white",
      text: "left",
      noPadding: false,
      duration: 3500,
    },
    {
      title: (
        <div className={styles.flexbox}>
          <p>we’ve created a</p>
          <span>personalized plan</span>
        </div>
      ),
      bg: "white",
      text: "left",
      noPadding: false,
      duration: 3500,
    },
    {
      title: (
        <div className={styles.flexbox}>
          <p>designed to get you</p>
          <p>
            to{" "}
            <span>
              {goal} {ms === "us" ? "lbs" : "kg"}{" "}
            </span>
          </p>
        </div>
      ),
      bg: "white",
      text: "left",
      noPadding: false,
      duration: 3500,
    },
    Boolean(qqOccasion) && Boolean(qqOccasionDate) && {
      title: (
        <div className={styles.flexbox}>
          <p>
            {isLoseWeight ? (
              <>
                and help you lose{" "}
                <span>
                  {Math.abs(
                    Math.ceil(
                      weight - eventWeight === 0 ? 1 : weight - eventWeight
                    )
                  )}{" "}
                  {ms === "us" ? "lbs" : "kg"}
                </span>
              </>
            ) : isGainWeight ? (
              <>
                and help you gain{" "}
                <span>
                  {Math.abs(
                    Math.ceil(
                      weight - eventWeight === 0 ? 1 : weight - eventWeight
                    )
                  )}{" "}
                  {ms === "us" ? "lbs" : "kg"}
                </span>
              </>
            ) : (
              <>
                and help you lose <span>{ms === "us" ? "1 lbs" : "1 kg"}</span>
              </>
            )}
          </p>

          {!!qqOccasion && (
            <p>
              by your <span>{OCCASIONS[qqOccasion]}</span>
            </p>
          )}
        </div>
      ),
      bg: "white",
      text: "left",
      noPadding: false,
      duration: 3500,
    },
    {
      title: (
        <div className={styles.flexbox}>
          <p>Let’s get started 🙌</p>
        </div>
      ),
      bg: "white",
      text: "left",
      noPadding: false,
      duration: 3500,
    },
  ].filter(Boolean);

  const settings = {
    infinite: false,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: false,
    draggable: false,
    autoplay: false,
    beforeChange: () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    afterChange: (current) => {
      const duration = sliderData[current].duration;

      if (current === sliderData.length - 1) {
        timeoutRef.current = setTimeout(() => {
          navigate("/paywall");
        }, duration);
      } else {
        timeoutRef.current = setTimeout(() => {
          sliderRef.current?.slickNext();
        }, duration);
      }
    },
  };

  useEffect(() => {
    if (loaded) {
      timeoutRef.current = setTimeout(() => {
        sliderRef.current?.slickNext();
      }, sliderData[0].duration);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [loaded]);

  if (!loaded) return <Loader isWalky={true} />;

  return (
    <div className={styles.container}>
      <Slider ref={sliderRef} {...settings}>
        {sliderData.map((slide, index) => (
          <div
            key={index}
            className={`${styles.slide} 
              ${slide.noPadding ? styles.noPadding : ""} 
               ${index === 0 ? styles.redBg : styles.whiteBg}`}
          >
            <div
              className={`${styles.content} ${
                slide.text === "center" ? styles.center : styles.left
              }`}
            >
              <h2 className={styles.title}>{slide.title}</h2>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
